<template>
  <rest-page :fetch-endpoint="fetchEndpoint">
    <component
      v-if="integration.components.overview"
      :is="integration.components.overview"
      :model="model"
    />
    <default-overview v-else :integration="integration" />
  </rest-page>
</template>

<script>
import RestPage from '@/common/components/rest/RestPage'
import DefaultOverview from '@/modules/integrations/pages/DefaultOverview'
import { projectEndpoint } from '@/core/helpers'

export default {
  name: 'IntegrationOverview',

  components: {
    RestPage,
    DefaultOverview
  },

  data() {
    return {
      model: null
    }
  },

  props: {
    integration: {
      type: Object,
      required: true
    },

    modelId: {
      type: Number,
      required: true
    }
  },

  computed: {
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `integrations/${this.modelId}`,
        handler: data => {
          this.model = data
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/integrations/pages/IntegrationOverview.vue